import React from "react";
import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import "../styles/ClientsDropdown.css";

//  Accept the new 'menuOpen' prop

function ClientsDropdown({ onLinkClick, scrolled, menuOpen }) {
  
  //  arrow is dark if scrolled OR mobile menu is open
  const isArrowDark = scrolled || menuOpen;

  return (
    <div className="clients-dropdown-wrapper">
      <FiChevronDown
        className={`dropdown-arrow ${
          isArrowDark ? "dropdown-arrow-dark" : "dropdown-arrow-light"
        }`}
      />
      <div className="clients-dropdown-content">
        <Link to="/clients/maharashtra" onClick={onLinkClick}>
          Maharashtra
        </Link>
        <Link to="/clients/daman" onClick={onLinkClick}>
          Daman
        </Link>
        <Link to="/clients/gujarat" onClick={onLinkClick}>
          Gujarat
        </Link>
        <Link to="/clients/andhra-pradesh" onClick={onLinkClick}>
          Andhra Pradesh
        </Link>
        <Link to="/clients/telangana" onClick={onLinkClick}>
          Telangana
        </Link>
      </div>
    </div>
  );
}

export default ClientsDropdown;
